/* tslint:disable */
/* eslint-disable */
/**
 * driverRegistration driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

export const OnboardingReason = {
        DOCUMENT_VERIFICATION: 'document_verification',
        DRIVER_BLOCKED_BY_FLEET: 'driver_blocked_by_fleet',
        DRIVER_CHANGING_FLEETS: 'driver_changing_fleets',
        ONSITE_VERIFICATION_REQUIRED: 'onsite_verification_required',
        MANDATORY_PHYSICAL_TRAINING: 'mandatory_physical_training',
        AIRWALLEX_ACCOUNT_CREATION: 'airwallex_account_creation',
        OVERSUPPLY: 'oversupply',
        INTERNAL: 'internal',
        INACTIVE_CITY: 'inactive_city',
        SIGNAGE: 'signage'
} as const;
export type OnboardingReason = typeof OnboardingReason[keyof typeof OnboardingReason];

